import forOwn from 'lodash/forOwn';
import { graphQlClient } from './graphql';
import createApiContext from './createApiContext';
import alexaService from './services/alexa';
import analyticsService from './services/analytics';
import authService from './services/auth';
import browseService from './services/browse';
import cmsService from './services/cms';
import configService from './services/config';
import favoritesService from './services/favorites';
import infoMessages from './services/infoMessages';
import { logging } from './services/logging';
import metricsService from './services/metrics';
import partnersService from './services/partners';
import { profile } from './services/profile';
import reauthService from './services/reauth';
import redirectInfoService from './services/redirectInfo';
import reportingService from './services/reporting';
import { reports } from './services/reports';
import subscriptionService from './services/subscription';
import { tune } from './services/tune';
import apiReauthWrapper from './utils/reauth/wrapper';
export * from './coordinators';
export * from './types';
const serviceCreators = {
    alexa: alexaService,
    analytics: analyticsService,
    auth: authService,
    browse: browseService,
    config: configService,
    favorites: favoritesService,
    logging,
    profile,
    redirectInfo: redirectInfoService,
    reports,
    subscription: subscriptionService,
    tune,
    cms: cmsService,
    infoMessages: infoMessages,
    metrics: metricsService,
    partners: partnersService,
    reporting: reportingService,
};
export default function tuneInApi(config, requestHeaders, onTrackingEvent) {
    const apiContext = createApiContext(config, requestHeaders, onTrackingEvent);
    const reauth = reauthService(config, apiContext);
    const applyReauth = apiReauthWrapper(reauth, apiContext);
    const services = { reauth, graphQlClient };
    graphQlClient.init(config.domains.graphQl, apiContext.headers, config.graphQlTransformAllowlist);
    forOwn(serviceCreators, (serviceCreator, name) => {
        services[name] = serviceCreator(config, apiContext, applyReauth, services);
    });
    return {
        setTokens: apiContext.setTokens,
        getTokens: apiContext.getTokens,
        clearTokens: apiContext.clearTokens,
        setCookies: apiContext.setCookies,
        setPartnerId: apiContext.setPartnerId,
        setUsername: apiContext.setUsername,
        setLatLong: apiContext.setLatLong,
        setSerial: apiContext.setSerial,
        updateReportingContext: apiContext.updateReportingContext,
        addHeaders: apiContext.addHeaders,
        clearHeaders: apiContext.clearHeaders,
        ...services,
    };
}
